// extracted by mini-css-extract-plugin
export default {"searchBox":"googleAutoComp_searchBox__BTwhm","closeBtn":"googleAutoComp_closeBtn__0G8+-"};